import React from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";

const FTOReport: React.FC = () => {
  return (
    <Container className="py-5">
      <Row className="mb-5">
        <Col lg={8} className="mx-auto text-center">
          <h1 className="display-4 fw-bold mb-4">
            Freedom-to-Operate Analysis
          </h1>
          <p className="lead text-muted mb-4">
            Fyled AI enables innovators to comprehensively assess the IP
            landscape for their inventions with just a few clicks, minimizing
            legal risks and identifying potential barriers to market entry.
          </p>
          <Button variant="primary" size="lg" className="rounded-pill px-4">
            Request Analysis
          </Button>
        </Col>
      </Row>

      <Row className="mb-5">
        <Col lg={10} className="mx-auto">
          <Card className="border-0 shadow-sm">
            <Card.Body className="p-5">
              <h2 className="mb-4">What is an FTO Analysis?</h2>
              <p>
                A Freedom-to-Operate (FTO) analysis determines whether your
                product or technology can be commercialized without infringing
                on existing patents or intellectual property rights. Our
                AI-powered solution helps identify potential IP obstacles before
                you invest significant resources in development.
              </p>

              <h2 className="mb-4 mt-5">How Our FTO Analysis Works</h2>
              <Row className="g-4">
                <Col md={4}>
                  <div className="text-center mb-3">
                    <div
                      className="bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                      style={{ width: "60px", height: "60px" }}
                    >
                      <h3 className="m-0">1</h3>
                    </div>
                    <h4>Upload Your Invention</h4>
                    <p className="text-muted">
                      Submit your invention details, designs, or descriptions
                      through our secure portal.
                    </p>
                  </div>
                </Col>
                <Col md={4}>
                  <div className="text-center mb-3">
                    <div
                      className="bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                      style={{ width: "60px", height: "60px" }}
                    >
                      <h3 className="m-0">2</h3>
                    </div>
                    <h4>AI Analysis</h4>
                    <p className="text-muted">
                      Our advanced AI scans millions of patents and identifies
                      potential conflicts.
                    </p>
                  </div>
                </Col>
                <Col md={4}>
                  <div className="text-center mb-3">
                    <div
                      className="bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                      style={{ width: "60px", height: "60px" }}
                    >
                      <h3 className="m-0">3</h3>
                    </div>
                    <h4>Comprehensive Report</h4>
                    <p className="text-muted">
                      Receive a detailed report with actionable insights and
                      risk assessment.
                    </p>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="mb-5">
        <Col lg={10} className="mx-auto">
          <Card className="border-0 shadow-sm">
            <Card.Body className="p-5">
              <h2 className="mb-4">Benefits of Our FTO Analysis</h2>
              <Row className="g-4">
                <Col md={6}>
                  <div className="d-flex mb-4">
                    <div className="flex-shrink-0">
                      <i className="bi bi-shield-check fs-2 text-primary"></i>
                    </div>
                    <div className="ms-3">
                      <h4>Risk Mitigation</h4>
                      <p className="text-muted">
                        Identify potential IP conflicts early to avoid costly
                        litigation and redesigns.
                      </p>
                    </div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="d-flex mb-4">
                    <div className="flex-shrink-0">
                      <i className="bi bi-lightning fs-2 text-primary"></i>
                    </div>
                    <div className="ms-3">
                      <h4>Accelerated Decision-Making</h4>
                      <p className="text-muted">
                        Get comprehensive results in days instead of weeks with
                        our AI-powered technology.
                      </p>
                    </div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="d-flex mb-4">
                    <div className="flex-shrink-0">
                      <i className="bi bi-cash-stack fs-2 text-primary"></i>
                    </div>
                    <div className="ms-3">
                      <h4>Cost-Effective</h4>
                      <p className="text-muted">
                        Our automated approach significantly reduces the cost
                        compared to traditional manual searches.
                      </p>
                    </div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="d-flex mb-4">
                    <div className="flex-shrink-0">
                      <i className="bi bi-globe fs-2 text-primary"></i>
                    </div>
                    <div className="ms-3">
                      <h4>Global Coverage</h4>
                      <p className="text-muted">
                        Our database covers patents from major jurisdictions
                        worldwide.
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col lg={8} className="mx-auto text-center">
          <h2 className="mb-4">Ready to Secure Your Innovation?</h2>
          <p className="lead text-muted mb-4">
            Get started with our FTO analysis today and move forward with
            confidence.
          </p>
          <Button variant="primary" size="lg" className="rounded-pill px-4">
            Request Your FTO Report
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default FTOReport;
